import {
  Button, Tooltip,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { object } from 'prop-types';
import ysq from '@/assets/myApplication/status_ysq.png';
import sptg from '@/assets/myApplication/status_sptg.png';
import spwtg from '@/assets/myApplication/status_spwtg.png';
import cancel from '@/assets/myApplication/status_qx.png';
import transformationProjectPng from '@/assets/myApplication/transformation-financing.png';

const statusObj = {
  0: { name: '已申请', class: '#3E7EFF', icon: ysq },
  1: { name: '审批通过', class: '#3E7EFF', icon: sptg },
  5: { name: '审批未通过', class: '#E54545', icon: spwtg },
  9: { name: '已取消', class: '#999999', icon: cancel },
};

export default function TransformationProjectCard(props) {
  const Navigate = useNavigate();
  const { data, onCancel, onSchedule } = props;
  function getDate(e) {
    const day = e.split(' ');
    return day[0];
  }
  return (
    <div className="myapplication__list-row">
      <div className="myapplication__status">
        <img src={statusObj[data.status]?.icon} alt="" width={130} height={35} />
        <span style={{ color: statusObj[data.status]?.class }} className="myapplication__status-text">{statusObj[data.status]?.name}</span>
      </div>
      <div className="myapplication__list-row-img">
        <img src={transformationProjectPng} alt="" width={250} height={75} />
      </div>
      <div className="myapplication__list-row-con" style={{ alignItems: 'center', gap: '10px 10px', gridTemplateColumns: '250px 240px 180px 140px' }}>
        <div>
          <div className="myapplication__list-row-name">
            <Tooltip title={data.projectName}>
              <span className="myapplication__list-pro-name">{data.projectName || '-'}</span>
            </Tooltip>
            <span className="tagBlue">转型项目</span>
          </div>
        </div>
        <div className="margin-right20">
          <div>转型路径</div>
          <div className="myapplication__list-row-title">
            {data.transformationRoute || '-'}
          </div>
        </div>
        <div className="margin-right20">
          <div>总贷款金额</div>
          <div className="myapplication__list-row-title">
            {data.totalLoanDemand}
            万元
          </div>
        </div>
        <div className="margin-right20">
          <div>申请时间</div>
          <div className="myapplication__list-row-title">{getDate(data.gmtCreate)}</div>
        </div>
      </div>
      <div className="btn-box">
        <Button type="primary" onClick={onSchedule}>
          进度查询
        </Button>
        {
          data?.status === 0 && (
            <Button type="primary" ghost onClick={onCancel}>
              取消申请
            </Button>
          )
        }
        {
          data?.status === 12 && (
            <Button
              type="primary"
              ghost
              onClick={() => {
                Navigate(`/majorFinancing/application?backId=${data?.applicationId}`);
              }}
            >
              重新申请
            </Button>
          )
        }
      </div>
    </div>
  );
}

TransformationProjectCard.propTypes = {
  data: object,
  onSchedule: () => {},
  onCancel: () => {},
};
